export default "dist/images/block-notification-large-icon.3879721.png";